// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-3a295a08]{padding:16px}.page-title[data-v-3a295a08]{font-size:18px;font-weight:600;margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
